var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":_vm.id}}),(_vm.loadTime)?_c('loader',{attrs:{"timeout":this.loadTime,"message":"Loading chart"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }